import type { ReactElement } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';
import { FetchErrorCallout } from '@/components/ui/fetch-error-callout';

interface FamilyRecordErrorStateProps {
  readonly error: Error;
  readonly onRetry: () => void;
}

/**
 * Page-level error for unrecoverable family fetch failures. `not_found`
 * is handled separately by the route (renders the global NotFoundPage).
 */
export function FamilyRecordErrorState({
  error,
  onRetry,
}: FamilyRecordErrorStateProps): ReactElement {
  const { t } = useTranslation();
  return (
    <div className="p-6 max-w-xl mx-auto">
      <FetchErrorCallout
        error={error}
        heading={t('routes.family.error.heading')}
        message={t('routes.family.error.message')}
        codeLabel={t('routes.family.error.codeLabel')}
        headingAs="h2"
        actions={
          <>
            <Button onClick={onRetry}>{t('routes.family.error.retry')}</Button>
            <Button variant="outline" asChild>
              <Link to="/browse/families">{t('routes.family.error.backToList')}</Link>
            </Button>
          </>
        }
      />
    </div>
  );
}
